import React, { useState } from "react";
import styled from "styled-components";
import { Button, Stack } from "@mui/material";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import TeamMemberAddModal from "./team-member-add-modal";

const Card = styled(Button)`
    width: 320px;
    height: 87px;
    border: ${({ theme }) => `2px dashed ${theme.palette.background.paper}`};
    border-radius: 6px;
    color: ${({ theme }) => theme.palette.text.secondary};
`;
const TeamMemberAddCard = ({ team, user }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    return (
        <>
            <Card onClick={() => setIsModalOpen(true)}>
                <Stack direction="row" spacing={1} style={{ width: "100%" }}>
                    <PersonAddIcon />
                    <span>add / invite user</span>
                </Stack>
            </Card>
            <TeamMemberAddModal
                open={isModalOpen}
                handleClose={() => setIsModalOpen(false)}
                team={team}
                user={user}
            />
        </>
    );
};

export default TeamMemberAddCard;
